import { Divider, MenuItem, Select, Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { SHARING_ACCESS, EDITOR_ONLY_ACCESS } from 'constants/sharing-access';

export const PeopleWithAccess = ({ title = 'People with access', children }) => {
  return (
    <Stack spacing={1}>
      <Typography
        variant="subtitle2"
        sx={{ fontWeight: 500 }}
      >
        {title}
      </Typography>
      <Stack spacing={0.5}>{children}</Stack>
    </Stack>
  );
};

export const Account = ({ children }) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
    >
      {children}
    </Stack>
  );
};

export const AccountName = ({ accountName = '' }) => {
  return (
    <Typography
      variant="subtitle2"
      sx={{
        fontWeight: 400,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '65%',
      }}
    >
      {accountName}
    </Typography>
  );
};

export const AccountAccess = ({ accountAccess = '' }) => {
  return (
    <Typography
      variant="subtitle2"
      color="text.secondary"
      sx={{ fontWeight: 400, paddingRight: '16px' }}
    >
      {accountAccess}
    </Typography>
  );
};

export const AccessOptions = ({ value = '', onChange = () => {}, editorOnly = false }) => {
  return (
    <Select
      value={value}
      renderValue={(selected) => (selected === 'Write' ? 'Editor' : 'Viewer')}
      sx={{
        '& .MuiSelect-select': { padding: '0px 8px' },
        '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
      }}
      onChange={(e) => onChange(e.target.value === 'Write' ? 'Read,Write' : e.target.value)}
    >
      {(editorOnly ? EDITOR_ONLY_ACCESS : SHARING_ACCESS).map((item) => (
        <MenuItem
          value={item.access}
          key={item.id}
          sx={{ fontSize: '14px' }}
        >
          <Stack
            direction="row"
            alignItems="center"
            spacing={2}
          >
            <CheckIcon
              fontSize="small"
              color={value === item.access ? 'primary' : 'inherit'}
              sx={{ color: value === item.access ? undefined : '#ffffff' }}
            />
            <AccountName accountName={item.name} />
          </Stack>
        </MenuItem>
      ))}
      <Divider />
      <MenuItem
        value="Remove"
        sx={{ fontSize: '14px' }}
      >
        Remove access
      </MenuItem>
    </Select>
  );
};

PeopleWithAccess.Account = Account;
PeopleWithAccess.AccountName = AccountName;
PeopleWithAccess.AccountAccess = AccountAccess;
PeopleWithAccess.AccessOptions = AccessOptions;
